import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { DataService } from 'src/app/main/shared/services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { LightningMapService } from '../lightning-map/lightning-map.service';
import { LightningDashboardService } from '../lightning-dashboard.service';

@Component({
  selector: 'app-lightning-sidebar',
  templateUrl: './lightning-sidebar.component.html',
  styleUrls: ['./lightning-sidebar.component.scss']
})
export class LightningSidebarComponent implements OnInit, OnDestroy {
  queryParams: any = {};
  subscriptions: any = [];
  isInitialLoad: boolean = false;
  destroy: any = new Subject();
  sessionStorage: any = { params: {} };

  selectedTimeFilter: string = 'all';

  timeFilterOptions = [
    { label: 'Last 5 Mins', value: '5min_record' },
    { label: 'Last 10 Mins', value: '10min_record' },
    { label: 'Last 15 Mins', value: '15min_record' },
    { label: 'All', value: 'all' }
  ];

  constructor(
    private utils: UtilsService,
    private dataService: DataService,
    private gisMapComp: GisDimsMapComponent,
    private lightningMapSrv: LightningMapService,
    private lightningDataSrv: LightningDashboardService
  ) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  subscribeEvents() {
    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.utils.setSelectedParams(this.queryParams);
        }
      }
    });
    this.subscriptions.push(selectedParamsRef);
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }


  onTimeFilterChange() {
    this.gisMapComp.injectedService['renderMarkersForFilter'](this.gisMapComp, this.selectedTimeFilter);
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'LIGHTNING';
    if (this.isInitialLoad) {
      let metaInfo: any = localStorage.getItem('metaInfo');
      let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
      let finalMetaInfo = metaInfoJson;
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      currentUrlParams['lightningView'] = 'observed';
      currentUrlParams['forecastLength'] = '24';
      const userLocationConfig = this.dataService.formQuerParamsVariables(finalMetaInfo.userDetailsJson.data.location, finalMetaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1];
      currentUrlParams['locName'] = currentLocations[0];
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      this.isInitialLoad = false;
    }
    this.utils.setSelectedParams(currentUrlParams);
  }

  ngOnDestroy() {
    this.selectedTimeFilter = 'all';
    this.lightningMapSrv.renderMarkersForFilter(this.gisMapComp, 'all');
    this.destroy.next();
    this.destroy.complete();
    this.subscriptions.forEach((sub:any) => sub.unsubscribe());
    this.lightningDataSrv.setMetaInfo();
    this.lightningMapSrv.resetSessionState();
  }
}
